import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import styles from '../../../styles/logpost.module.css';
import 'swiper/css';
import 'swiper/css/navigation';
import LogPostCard from './LogPostCard';
import { dayjs } from '../../../utils/dayjs-utils';
import { LogPost } from './types';

interface LogPostsProps {
  logPostData: LogPost[];
  yearMonth: string;
  creatorDetails: Record<any, any>;
}

function LogPosts({ logPostData, yearMonth, creatorDetails }: LogPostsProps) {
  return (
    <div className={styles.logPostsWrapper}>
      <div className={styles.logPostsMonth}>{dayjs(`${yearMonth}-15`).format('MMMM YYYY')}</div>
      <div className={styles.swiperContainer}>
        <Swiper
          breakpoints={{
            400: { slidesPerView: 1, spaceBetween: 0 },
            576: { slidesPerView: 1, spaceBetween: 0 },
            768: { slidesPerView: 1, spaceBetween: 0 },
            998: { slidesPerView: 1, spaceBetween: 0 },
            1000: { slidesPerView: 1, spaceBetween: 0 },
            1300: { slidesPerView: 2, spaceBetween: 0 },
            1600: { slidesPerView: 3, spaceBetween: 0 },
            1800: { slidesPerView: 3.5, spaceBetween: 32 },
          }}
          slidesPerView={3.5}
          spaceBetween="32px"
          navigation
          modules={[Navigation]}
        >
          {logPostData.map((data: any) => (
            <SwiperSlide key={data.logPostId}>
              <LogPostCard data={data} creatorDetails={creatorDetails} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={styles.mobileContainer}>
        {logPostData.map((data: any) => (
          <LogPostCard data={data} creatorDetails={creatorDetails} key={data.logPostId} />
        ))}
      </div>
    </div>
  );
}

export default LogPosts;
